/** Debug token should be imported before any other firebase imports */
/** You might need to register your debug token in the Firebase Console */
if (typeof window !== 'undefined') {
	if (process.env.NODE_ENV === 'development') {
		console.log('App Check is enabled in development mode')
		self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.NEXT_PUBLIC_FIREBASE_APPCHECK_DEBUG_TOKEN
	}
}
import {getApps, initializeApp} from 'firebase/app'
import {getToken, initializeAppCheck, ReCaptchaV3Provider, AppCheck} from 'firebase/app-check'
import {
	browserLocalPersistence,
	browserSessionPersistence,
	getAuth,
	indexedDBLocalPersistence,
	initializeAuth,
} from 'firebase/auth'
import {getStorage} from 'firebase/storage'
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
	apiKey: process.env.NEXT_PUBLIC_FB_API_KEY,
	authDomain: process.env.NEXT_PUBLIC_FB_AUTH_DOMAIN,
	projectId: process.env.NEXT_PUBLIC_FB_PROJECT_ID,
	storageBucket: process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET,
	messagingSenderId: process.env.NEXT_PUBLIC_FB_MESSAGING_SENDER_ID,
	appId: process.env.NEXT_PUBLIC_FB_APP_ID,
	measurementId: process.env.NEXT_PUBLIC_FB_MEASUREMENT_ID,
}

const existingApps = getApps()

// Initialize Firebase

const firebaseApp = existingApps.length === 0 ? initializeApp(firebaseConfig) : undefined

// Initialize App Check only on the client side
let appCheck: AppCheck | undefined
if (typeof window !== 'undefined') {
	appCheck = initializeAppCheck(firebaseApp, {
		provider: new ReCaptchaV3Provider(process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY),
		isTokenAutoRefreshEnabled: true,
	})
}
const getMyAuth = () => {
	if (firebaseApp) {
		const auth = initializeAuth(firebaseApp, {
			persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
		})
		return auth
	}
	return getAuth(firebaseApp)
}
export const auth = getMyAuth()
export const storage = getStorage(firebaseApp)

export const getAppCheckToken = async () => {
	if (!appCheck) {
		throw new Error('This function should only be called on the client side.')
	}
	const tokenResult = await getToken(appCheck)
	return tokenResult.token
}

export default firebaseApp
